import Lookbooks from './views/Lookbooks.vue';
import Main from './views/Main.vue';
import Auth from './views/Auth.vue';
import Registration from './views/Registration.vue';
import Notfound from './views/Notfound.vue';
import Catalog from './views/Catalog.vue';
import Category from './views/Category.vue';
import Favorite from './views/Favorite.vue';
import Detail from './views/Detail.vue';
import Notifications from './views/Notifications.vue';
import Profile from './views/Profile.vue';
import Info from './views/Info.vue';
import Loyalty from './views/Loyalty.vue';
import Boutiques from './views/Boutiques.vue';
import Orders from './views/Orders.vue';
import OrderDetail from './views/OrderDetail.vue';
import WaitingList from './views/WaitingList.vue';
import Personal from './views/Personal.vue';
import Address from './views/Address.vue';
import Basket from './views/Basket.vue';
import Order from './views/Order.vue';
import OrderSuccess from './views/OrderSuccess.vue';
import Contacts from './views/Contacts.vue';
import Certificates from './views/Certificates.vue';
import CertificatesBuy from './views/CertificatesBuy.vue';
import CertificatesSuccess from './views/CertificatesSuccess.vue';
import Blog from './views/Blog.vue';
import BlogDetail from './views/BlogDetail.vue';
import Page from './views/Page.vue';
import HistoryBuy from './views/HistoryBuy.vue';
import HistoryBuyDetail from './views/HistoryBuyDetail.vue';
import BonusHistory from './views/BonusHistory.vue';


import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import store from './store'

const ifNotAuthenticated = (to, from, next) => {
    //next();return;

    if (!store.getters.isAuth) {
        next()
        return
    }
    next('/')
}

const ifAuthenticated = (to, from, next) => {

    /*next();
    return;*/

    /*if (from.name == undefined) {
        next();
        return;
    }*/
    if (store.getters.isAuth) {
        next()
        return
    }
    next('/auth/')
}

export default new createRouter({
    // mode: 'history',
    history: createWebHistory(),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    },
    //base: process.env.BASE_URL,
    routes: [
        {
            path: '/auth/',
            component: Auth,
            name:'auth',
            meta: {layout: 'main', name: 'Профиль', auth:'not'},
            //beforeEnter: ifNotAuthenticated,
        },
        /*{
            path: '/registration/',
            component: Registration,
            name:'registration',
            meta: {layout: 'main', name: 'Регистрация'},
            beforeEnter: ifNotAuthenticated,
        },*/
        {
            path: '/',
            component: Main,
            name:'main',
            meta: {layout: 'main', name: '', main_page: true}
        },
        {
            path: '/catalog/',
            component: Catalog,
            name:'catalog',
            meta: {layout: 'main', name: 'Каталог'},
            //beforeEnter: ifAuthenticated
        },
        {
            path: '/category/:id/',
            component: Category,
            name:'category',
            meta: {layout: 'main', name: 'Категория', search: true},
            //beforeEnter: ifAuthenticated
        },
        /*{
            path: '/category/new/',
            component: Category,
            name:'categorynew',
            meta: {layout: 'main', name: 'Новинки'},
            //beforeEnter: ifAuthenticated
        },
        {
            path: '/category/sale/',
            component: Category,
            name:'categorysale',
            meta: {layout: 'main', name: 'Распродажа'},
            //beforeEnter: ifAuthenticated
        },*/
        {
            path: '/favorite/',
            component: Favorite,
            name:'favorite',
            meta: {layout: 'main', name: 'Избранное', search: true},
            //beforeEnter: ifAuthenticated
        },
        {
            path: '/detail/:id/',
            component: Detail,
            name:'detail',
            meta: {layout: 'main', name: '', back: true, search: true},
            //beforeEnter: ifAuthenticated
        },
        {
            path: '/notifications/',
            component: Notifications,
            name:'notifications',
            meta: {layout: 'main', name: 'Уведомления', back: true},
            //beforeEnter: ifAuthenticated
        },
        {
            path: '/profile/',
            component: Profile,
            name:'profile',
            meta: {layout: 'main', name: 'Профиль', auth:'yes'},
            //beforeEnter: ifAuthenticated,
        },
        {
            path: '/info/',
            component: Info,
            name:'info',
            meta: {layout: 'main', name: 'Информация'},
            //beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/loyalty/',
            component: Loyalty,
            name:'loyalty',
            meta: {layout: 'main', name: 'Программа лояльности', back: true},
            //beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/boutiques/',
            component: Boutiques,
            name:'boutiques',
            meta: {layout: 'main', name: 'Бутики', prev: '/profile/'},
            //beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/orders/',
            component: Orders,
            name:'orders',
            meta: {layout: 'main', name: 'Заказы', prev: '/profile/', auth:'yes'},
            //beforeEnter: ifAuthenticated,
        },
        {
            path: '/order/:id/',
            component: OrderDetail,
            name:'orderdetail',
            meta: {layout: 'main', name: 'Заказ', prev: '/orders/', auth:'yes'},
            //beforeEnter: ifAuthenticated
        },
        {
            path: '/historybuy/',
            component: HistoryBuy,
            name:'historybuy',
            meta: {layout: 'main', name: 'История покупок', prev: '/profile/', auth:'yes'},
            //beforeEnter: ifAuthenticated,
        },
        {
            path: '/historybuy/:id/',
            component: HistoryBuyDetail,
            name:'HistoryBuyDetail',
            meta: {layout: 'main', name: 'Покупка', prev: '/historybuy/', auth:'yes'},
            //beforeEnter: ifAuthenticated
        },
        {
            path: '/bonus-history/',
            component: BonusHistory,
            name:'bonus-history',
            meta: {layout: 'main', name: 'История бонусов', prev: '/profile/', auth:'yes'},
            //beforeEnter: ifAuthenticated,
        },
        {
            path: '/waiting-list/',
            component: WaitingList,
            name:'waiting-list',
            meta: {layout: 'main', name: 'Лист ожидания', prev: '/profile/', auth:'yes'},
            //beforeEnter: ifAuthenticated,
        },
        {
            path: '/personal/',
            component: Personal,
            name:'personal',
            meta: {layout: 'main', name: 'Личные данные', prev: '/profile/', auth:'yes'},
            //beforeEnter: ifAuthenticated,
        },
        {
            path: '/address/',
            component: Address,
            name:'address',
            meta: {layout: 'main', name: 'Адрес доставки', prev: '/profile/', auth:'yes'},
            //beforeEnter: ifAuthenticated,
        },
        {
            path: '/basket/',
            component: Basket,
            name:'basket',
            meta: {layout: 'main', name: 'Корзина', prev: '/', hidebasket: true},
            //beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/order/',
            component: Order,
            name:'order',
            meta: {layout: 'main', name: 'Оформление заказа', prev: '/basket/', hidebasket: true},
            //beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/order/success/',
            component: OrderSuccess,
            name:'order_success',
            meta: {layout: 'main', hidebasket: true, hidenotify: true},
            //beforeEnter: ifNotAuthenticated,
        },
        /*{
            path: '/api/order/',
            component: OrderSuccess,
            name:'order_success',
            meta: {layout: 'main', hidebasket: true, hidenotify: true},
            //beforeEnter: ifNotAuthenticated,
        },*/
        {
            path: '/contacts/',
            component: Contacts,
            name:'contacts',
            meta: {layout: 'main', name: 'Контакты', prev: '/profile/'},
            //beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/certificates/',
            component: Certificates,
            name:'certificates',
            meta: {layout: 'main', name: 'Подарочные сертификаты', prev: '/profile/'},
            //beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/certificates/buy/',
            component: CertificatesBuy,
            name:'certificates_buy',
            meta: {layout: 'main', name: 'Оформление', prev: '/certificates/'},
            //beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/certificates/success/',
            component: CertificatesSuccess,
            name:'certificates_success',
            meta: {layout: 'main', name: 'Спасибо за заказ', hidebasket: true, hidenotify: true},
            //beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/blog/',
            component: Blog,
            name:'blog',
            meta: {layout: 'main', name: 'Блог', prev: '/profile/'},
            //beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/blog/:id/',
            component: BlogDetail,
            name:'blog_detail',
            meta: {layout: 'main',  prev: '/blog/'},
            //beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/page/:id/',
            component: Page,
            name:'page',
            meta: {layout: 'main',  back: true},
            //beforeEnter: ifNotAuthenticated,
        },
        {
            path: '/lookbooks/',
            name: 'lookbooks',
            component: Lookbooks,
            meta: {layout: 'main', name: 'Образы', back: true}
        },
        {
            path: '/:pathMatch(.*)*',
            component: Notfound,
            name:'notfound',
            meta: {layout: 'main', title: 'Ошибка'}
        },
    ]
})
